import "./index.css";
import App from "./App";
import React from "react";
import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Assets/Theme/tokens.css";
import "./Assets/Theme/fonts.css";
import "./Assets/Theme/bootstrap-bridge.css";
import reportWebVitals from "./reportWebVitals";
import { store, persistor } from "./Redux/configureStore";
import { PersistGate } from "redux-persist/integration/react";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    {/* <React.StrictMode> */}
      <PersistGate persistor={persistor}>
        <App />
      </PersistGate>
    {/* </React.StrictMode> */}
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
